import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ReactGA4 from "react-ga4";
import Handlebars from "handlebars";

import { resetAppointment } from "../appointments/appointmentSlice";

import { scrollToTop, sendToWindowDataLayer } from "../utils";

import { postBookingConfig } from "../utils/api";

import {
  WeeConfetti,
  opaquePopoverTextBox,
  borderColor,
  shadowColor,
  shadow,
  rounded,
} from "css";

const AppointmentConfirmed = ({ appointment }) => {
  const [confirmationMessage, setConfirmationMessage] = useState(
    "We'll see you soon!"
  );
  const dispatch = useDispatch();

  useEffect(() => {
    postBookingConfig(appointment).then(() => {
      sendToWindowDataLayer("dc-service-booked", "dc-service-booked");

      ReactGA4.event({
        category: "Appointments",
        action: "scheduled",
        label: "APPOINTMENT SCHEDULED",
        utm_data: appointment?.utmData,
      });
    });
  }, []);

  useEffect(() => {
    scrollToTop();
  });

  useEffect(() => {
    buildHandlebars();
  }, []);

  const buildHandlebars = () => {
    const template = Handlebars.compile(
      appointment?.shopData?.messages?.confirmationMessage ??
        "Your appointment has been successfully booked! We look forward to seeing you soon."
    );

    const data = {
      your_service: appointment?.service,
      on_date: appointment?.date,
      at_time: appointment?.time,
    };
    const result = template(data);
    setConfirmationMessage(result);
  };

  const confirmLeavePage = () => {
    const outlet = appointment?.shopData?.shopContact?.socialLinks[0]?.url;
    window.location.replace(outlet);
  };

  return (
    <div className="mx-6 pt-6 pb-6">
      <center>
        <div
          className={opaquePopoverTextBox}
          style={{ opacity: 1, borderColor: appointment?.shopData?.color }}
        >
          <div className="pt-5 mb-2 text-2xl font-bold">
            Appointment Confirmed!
          </div>
          <div className="mx-6">
            <pre
              style={{
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
                overflow: "auto",
              }}
            >
              {confirmationMessage}
            </pre>
          </div>
          <div className="mt-2 text-3xl font-bold">🎉</div>
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white"></div>
            <img
              src="https://bookings.d14e.io/images/skyline.png"
              alt="Skyline"
              className="w-full h-full object-cover mt-10"
            />
          </div>
          <div className="pb-5">
            <span
              className={`py-1 px-8 w-[100px] cursor-pointer underline border-solid border-[1px] ${borderColor} mx-5 ${rounded} ${shadow} ${shadowColor}`}
              onClick={confirmLeavePage}
              style={{ borderColor: appointment?.shopData?.color }}
            >
              Close
            </span>
          </div>
        </div>
      </center>
      <WeeConfetti />
    </div>
  );
};

export { AppointmentConfirmed };
